/**
 * komradd-pdp.js
 * Controls the sequential, alternating pulse animations on the PDP cart buttons.
 *
 * Sequence:
 *   1. Add to Cart  animates (one cycle, 0→100, ring expands outward)
 *   2. Short pause
 *   3. Buy It Now   animates (one cycle, 0→100)
 *   4. Rest, then repeat from step 1.
 *
 * CSS does the visual work; JS only adds/removes the `.pdp-active` class.
 */
(function () {
  'use strict';

  // Skip for users who prefer reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ATC_DURATION   = 1800; // ms — must match CSS animation length
  var BIN_DURATION   = 1800; // ms
  var PAUSE_BETWEEN  =  400; // ms gap between ATC and BIN
  var CYCLE_REST     =  900; // ms rest before the cycle repeats

  function getATC() {
    return document.querySelector('.product-form__buttons .product-form__submit');
  }

  function getBIN() {
    return document.querySelector(
      '.product-form__buttons .shopify-payment-button .shopify-payment-button__button--unbranded'
    );
  }

  /**
   * Remove, force-reflow, then re-add the class so the CSS animation
   * always restarts from frame 0, even if the class was already present.
   */
  function triggerAnimation(el, cls) {
    el.classList.remove(cls);
    void el.offsetWidth; // flush styles → restart animation
    el.classList.add(cls);
  }

  function runCycle() {
    var atc = getATC();
    var bin = getBIN();

    // If either button isn't in the DOM yet (e.g. Shopify dynamic payment
    // button still loading), wait and retry.
    if (!atc || !bin) {
      setTimeout(runCycle, 600);
      return;
    }

    // Step 1 — animate Add to Cart
    triggerAnimation(atc, 'pdp-active');

    // Step 2 — after ATC finishes + brief pause, animate Buy It Now
    setTimeout(function () {
      var binEl = getBIN();
      if (binEl) triggerAnimation(binEl, 'pdp-active');

      // Step 3 — after BIN finishes + rest period, loop
      setTimeout(runCycle, BIN_DURATION + CYCLE_REST);
    }, ATC_DURATION + PAUSE_BETWEEN);
  }

  // Start after a short delay so the page (and dynamic buttons) can settle
  function init() {
    setTimeout(runCycle, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();